module.exports = __webpack_public_path__ + "img/49598f2481c24e6bd55d14a7bd3d8a50.png";